var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"frameAdmin"}},[_c('iframe',{staticStyle:{"width":"100%"},attrs:{"src":_vm.baseUrl + _vm.$store.state.iframeUrl,"id":"iframeBox","frameborder":"0","scrolling":"auto","height":_vm.iframeHeight}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eac3046","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frame/admin.vue
// module id = null
// module chunks = 